import { all, put, takeLatest, call } from 'redux-saga/effects';
import { handleRequestError } from 'services/api/apiTools';
import ApiService from 'services/api';
import * as actions from './actions';

export function* getNotificationListSaga() {
  let requestValue;
  try {
    requestValue = yield call(ApiService.getNotificationList);
  } catch (errors) {
    handleRequestError(errors);
    yield put(actions.getNotificationList.failure());
    return;
  }

  yield put(actions.getNotificationList.success({ data: requestValue }));
}

export function* getEmployeeNotificationSaga(action) {
  const { id } = action.payload;

  let requestValue;
  try {
    requestValue = yield call(ApiService.getUserNotificationList, id);
  } catch (errors) {
    handleRequestError(errors);
    yield put(actions.getEmployeeNotification.failure());
    return;
  }

  yield put(
    actions.getEmployeeNotification.success({
      data: {
        [requestValue.account_id]: {
          notifications: requestValue.notifications || [],
          locations: requestValue.locations || [],
        },
      },
    })
  );
}

export function* updateEmployeeNotificationSaga(action) {
  const { id, data } = action.payload;

  try {
    yield call(ApiService.changeUserNotification, id, data);
  } catch (errors) {
    handleRequestError(errors);
    yield put(actions.updateEmployeeNotification.failure());
    return;
  }

  yield put(actions.getEmployeeNotification.start({ id }));
  yield put(actions.updateEmployeeNotification.success());
}

export function* getCustomerNotificationSaga(action) {
  const { id } = action.payload;

  let requestValue;
  try {
    requestValue = yield call(ApiService.getCustomerNotificationList, id);
  } catch (errors) {
    handleRequestError(errors);
    yield put(actions.getCustomerNotification.failure());
    return;
  }

  yield put(
    actions.getCustomerNotification.success({
      data: {
        [requestValue.account_id]: {
          notifications: requestValue.notifications || [],
          locations: requestValue.locations || [],
        },
      },
    })
  );
}

export function* updateCustomerNotificationSaga(action) {
  const { id, data } = action.payload;

  try {
    yield call(ApiService.changeCustomerNotification, id, data);
  } catch (errors) {
    handleRequestError(errors);
    yield put(actions.updateCustomerNotification.failure());
    return;
  }

  yield put(actions.getCustomerNotification.start({ id }));
  yield put(actions.updateCustomerNotification.success());
}

export function* notificationsSagas() {
  yield all([
    yield takeLatest(
      actions.getNotificationList.start,
      getNotificationListSaga
    ),
    yield takeLatest(
      actions.getEmployeeNotification.start,
      getEmployeeNotificationSaga
    ),
    yield takeLatest(
      actions.updateEmployeeNotification.start,
      updateEmployeeNotificationSaga
    ),
    yield takeLatest(
      actions.getCustomerNotification.start,
      getCustomerNotificationSaga
    ),
    yield takeLatest(
      actions.updateCustomerNotification.start,
      updateCustomerNotificationSaga
    ),
  ]);
}
